import storage from 'store'

export const MOBILE_CLOUD_VIEW_MODE_KEY = 'ViwoodsMobileCloudViewMode'
export const MOBILE_CLOUD_VIEW_MODE_EVENT = 'viwoods-mobile-cloud-view-mode-change'

export function normalizeMobileCloudViewMode(mode) {
  return mode == 'grid' ? 'grid' : 'list'
}

export function getMobileCloudViewMode(fallback = 'list') {
  return normalizeMobileCloudViewMode(storage.get(MOBILE_CLOUD_VIEW_MODE_KEY) || fallback)
}

export function setMobileCloudViewMode(mode, forceNotify = false) {
  const viewMode = normalizeMobileCloudViewMode(mode)
  const previousRaw = storage.get(MOBILE_CLOUD_VIEW_MODE_KEY)
  const previous = previousRaw ? normalizeMobileCloudViewMode(previousRaw) : ''
  storage.set(MOBILE_CLOUD_VIEW_MODE_KEY, viewMode)
  if (
    (previous != viewMode || forceNotify) &&
    typeof window !== 'undefined' &&
    typeof window.dispatchEvent == 'function'
  ) {
    window.dispatchEvent(new CustomEvent(MOBILE_CLOUD_VIEW_MODE_EVENT, { detail: { viewMode } }))
  }
  return viewMode
}
